module.exports = __webpack_public_path__ + "img/pro2.e5253971.png";